<div class="integration-status-indicator" [class]="getStatusClass() + ' ' + getSizeClass()">
  <!-- Status Icon and Text -->
  <div class="status-main">
    <mat-icon
      class="status-icon"
      [style.color]="getStatusColor()"
      [attr.aria-label]="getStatusText()"
    >
      {{ getStatusIcon() }}
    </mat-icon>
    <span class="status-text">{{ getStatusText() }}</span>
  </div>

  <!-- Unifier Badge -->
  <div class="unifier-badge" *ngIf="isSyncedFromUnifier()">
    <mat-icon class="unifier-icon" svgIcon="cloud_sync"></mat-icon>
    <span class="unifier-text">Unifier</span>
  </div>

  <!-- Detailed Information -->
  <div class="status-details" *ngIf="showDetails && status">
    <div class="detail-item" *ngIf="status.unifier_ref_number">
      <span class="detail-label">{{ 'integration.unifier_ref' | transloco }}:</span>
      <span class="detail-value">{{ status.unifier_ref_number }}</span>
    </div>
    <div class="detail-item" *ngIf="status.unifier_updated_at">
      <span class="detail-label">{{ 'integration.last_sync' | transloco }}:</span>
      <span class="detail-value">{{ getLastSyncTime() }}</span>
    </div>
  </div>

  <!-- No Status Available -->
  <div class="no-status" *ngIf="!status">
    <mat-icon class="no-status-icon" svgIcon="mat_solid:help_outline"></mat-icon>
    <span class="no-status-text">{{ 'integration.status_unavailable' | transloco }}</span>
  </div>
</div>
